import type { FC } from 'react';

import type { Nullable } from '@zen/utils/typescript';

import TerminalSelect, { type Terminal } from '../../TerminalSelect';
import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

interface Props extends FormFieldProps {
  isClearable?: boolean;
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormTerminalSelect: FC<Props> = (props) => {
  const { label, ...rest } = props;

  return (
    <FormField {...props}>
      {(field: { error: boolean; label: string; name: string; value: Nullable<Terminal> }, form: FormInstance<unknown>) => {
        const { label: fieldLabel, ...fieldRest } = field;

        return (
          <TerminalSelect
            {...rest}
            {...fieldRest}
            hasError={field.error}
            onChange={(value: Nullable<Terminal>) => {
              form.setFieldValue(field.name, value);
            }}
          />
        );
      }}
    </FormField>
  );
};

export type { Props as FormTerminalSelectProps };

export default FormTerminalSelect;
